
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface Feature {
  title: string;
  description: string;
}

const VaeSection = () => {
  const { t } = useTranslation('individuals');
  const features = t('vaeSection.features', { returnObjects: true }) as Record<string, Feature>;

  return (
    <section className="py-24 bg-background">
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-center bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange mb-6">
              {t('vaeSection.title')}
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-4xl mx-auto">
              {t('vaeSection.description')}
            </p>
          </div>

          <div className="space-y-8">
            {Object.values(features).map((feature, index) => (
              <div key={index} className="bg-card rounded-2xl p-8 border border-border hover:shadow-xl transition-all duration-300">
                <h3 className="text-xl font-semibold text-brand-orange mb-4">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href="/search"
              className="inline-flex items-center px-8 py-4 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl text-lg"
            >
              {t('vaeSection.cta')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VaeSection;
